import { MainMenu, Widget } from 'rangeConfig/@types';
import ChangeFrameColor from 'components/ProductSidebar/menus/Widgets/ChangeColor/ChangeFrameColor';
import ProductList from 'rangeConfig/shared/widgets/ProductList';
import * as R from 'ramda';
import withCategoryFilter from 'rangeConfig/shared/widgets/withCategoryFilter';
import ProductSwiper from 'rangeConfig/shared/widgets/ProductSwiper';
import hideDoors from 'rangeConfig/shared/behaviors/hideDoors';
import showDoors from 'rangeConfig/shared/behaviors/showDoors';
import platform from 'rangeConfig/shared/utils/platform';
import { depthFilter, widthFilterWithSizeLabel } from 'rangeConfig/shared/filters/configFilters';
import { framesTypeFilter } from 'rangeConfig/besta/filters/configFilters';
import withProducts from 'rangeConfig/shared/widgets/withProducts';
import framesProductListConfig from './productListConfig';
import ProductSortFilterWidget from 'rangeConfig/shared/widgets/ProductSortFilterWidget';

const FramesSwiper = R.pipe(
  withCategoryFilter([
    'frameWhite',
    'frameWSO',
    'frameGSW',
    'frameBlackBrown',
    'frameOak',
    'frameDarkGrey'
  ])
);

const TVBenchSwiper = R.pipe(
  withCategoryFilter([
    'tvBenchWhite',
    'tvBenchWSO',
    'tvBenchGSW',
    'tvBenchBlackBrown',
    'tvBenchOak',
    'tvBenchDarkGrey'
  ])
);

const widgets = {
  desktop: [
    { id: 'change-color', component: ChangeFrameColor },
    {
      id: 'besta-frames-sort-filter-widget',
      component: ProductSortFilterWidget
    } as Widget,
    { id: 'frames-product-list', component: withProducts(ProductList, framesProductListConfig) }
  ],
  mobile: [
    { id: 'change-color', component: ChangeFrameColor, title: 'storageone.colorFilterLabel' },
    {
      id: 'frame-product-list',
      component: FramesSwiper(withProducts(ProductSwiper, framesProductListConfig)),
      title: 'storageone.productListFramesTitle'
    },
    {
      id: 'tv-bench-product-list',
      component: TVBenchSwiper(withProducts(ProductSwiper, framesProductListConfig)),
      title: 'storageone.productListTvBenchesTitle'
    }
  ]
};

const filters = {
  desktop: [widthFilterWithSizeLabel, depthFilter, framesTypeFilter],
  mobile: [widthFilterWithSizeLabel, depthFilter]
};

const mainMenu: MainMenu = {
  menuTitle: 'storageone.productListFramesTitle',
  behaviors: {
    productGroupEntered: [hideDoors],
    productGroupExited: [showDoors]
  },
  filters: filters[platform],
  widgets: widgets[platform]
};

export default mainMenu;
